import { Breadcrumb, Button, Card, Col, Empty, Form, Input, message, Pagination, Row, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import gql from 'graphql-tag';
import React, { FormEvent, useState } from 'react';
import { Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { PageInfo } from 'src/types/base';
import { RedpackTemplate } from 'src/types/redpack';

const COUNT_PER_PAGE = 20;

export const RedpackListForm = (props: { form: WrappedFormUtils }) => {
  const GET_REDPACK_TEMPLATES = gql`
    query redpackTemplatesConnection($description: String, $take: Int, $skip: Int, $after: ID, $before: ID) {
      redpackTemplatesConnection(description: $description, take: $take, skip: $skip, after: $after, before: $before) {
        nodes {
          id
          name
          description
          minAmount
          maxAmount
          receiveLimit
          totalAmountLimit
        }
        pageInfo {
          totalCount
          startCursor
          endCursor
        }
      }
    }
  `;

  const [variables, setVariables] = useState<{
    description?: string;
    take: number;
    skip?: number;
    before?: number;
    after?: number;
  }>({
    skip: 0,
    take: COUNT_PER_PAGE,
  });
  const [description, setDescription] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  function onSubmit(e: FormEvent) {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      setCurrentPage(1);
      setDescription(values.description);
      setVariables({
        description: values.description,
        take: COUNT_PER_PAGE,
        skip: 0,
      });
    });
  }

  const Redpacktemplates = (form: WrappedFormUtils) => (
    <Query<{ redpackTemplatesConnection: { nodes: RedpackTemplate[]; pageInfo: PageInfo } }>
      query={GET_REDPACK_TEMPLATES}
      variables={variables}
    >
      {({ loading, error, data }) => {
        if (loading) return null;
        if (error) return `Error! ${error}`;
        if (!data) {
          // @ts-ignore
          return <Empty />;
        }
        const redpackTemplatesConnection = data.redpackTemplatesConnection;
        const { getFieldDecorator } = form;
        return (
          <>
            <Card>
              <Form onSubmit={onSubmit} style={{ marginBottom: 10 }}>
                <Row gutter={24}>
                  <Col xs={24} md={12} lg={9} xl={7} xxl={5}>
                    <FormItem label="描述">{getFieldDecorator('description')(<Input />)}</FormItem>
                    <Button style={{ marginRight: 8 }} type="primary" htmlType="submit" icon="search">
                      搜索
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
            <Table
              pagination={false}
              dataSource={redpackTemplatesConnection.nodes}
              rowKey={itme => `${itme.id}`}
              footer={() => (
                <Pagination
                  style={{ float: 'right', marginBottom: 16 }}
                  total={redpackTemplatesConnection.pageInfo.totalCount}
                  pageSize={variables.take}
                  current={currentPage}
                  onChange={nextPage => {
                    const pageSkip = (Math.abs(nextPage - currentPage) - 1) * COUNT_PER_PAGE;

                    if (nextPage > currentPage) {
                      setVariables({
                        description,
                        skip: pageSkip,
                        take: COUNT_PER_PAGE,
                        after: redpackTemplatesConnection.pageInfo.endCursor,
                      });
                    }
                    if (nextPage < currentPage) {
                      setVariables({
                        description,
                        skip: pageSkip,
                        take: COUNT_PER_PAGE,
                        before: redpackTemplatesConnection.pageInfo.endCursor,
                      });
                    }
                    setCurrentPage(nextPage);
                  }}
                />
              )}
            >
              <Table.Column key="id" dataIndex="id" title="id" />
              <Table.Column key="name" dataIndex="name" title="名称" />
              <Table.Column key="description" dataIndex="description" title="描述" />
              <Table.Column
                key="minAmount"
                dataIndex="minAmount"
                title="最小金额"
                render={minAmount => {
                  return Number(minAmount) / 100;
                }}
              />
              <Table.Column
                key="maxAmount"
                dataIndex="maxAmount"
                title="最大金额"
                render={maxAmount => {
                  return Number(maxAmount) / 100;
                }}
              />
              <Table.Column key="receiveLimit" dataIndex="receiveLimit" title="领取次数" />
              <Table.Column
                key="totalAmountLimit"
                dataIndex="totalAmountLimit"
                title="总金额"
                render={totalAmountLimit => {
                  return Number(totalAmountLimit) / 100;
                }}
              />
              <Table.Column key="detail" dataIndex="id" render={id => <Link to={`/redpack/${id}`}>详情</Link>} />
            </Table>
          </>
        );
      }}
    </Query>
  );

  return (
    <>
      <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
        <Breadcrumb.Item>
          <Link to={`/Home`}>首页</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>红包管理</Breadcrumb.Item>
      </Breadcrumb>
      <Card>{Redpacktemplates(props.form)}</Card>
    </>
  );
};
export const RedpackList = Form.create({ name: 'RedpackList' })(RedpackListForm);



// WEBPACK FOOTER //
// ./src/screens/redpack/RedpackList.tsx